/**
 * @fileoverview Barrel exports for the run-refine-v2 COMPOSITE agent.
 *
 * This is a composite agent that orchestrates two primitives in a pipeline:
 * - refine-synthesizer: Creates an editorial brief from findings/weaknesses/strengths
 * - draft-refiner-v2: Refines the chapter based on the editorial brief
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Pipeline orchestration logic using executePipeline
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  HookInputSchema,
  FindingSchema,
  WeaknessSchema,
  StrengthSchema,
  type Input,
  type Output,
  type HookInput,
} from './schema';

// Flow
export { flow, runRefineV2AgentFlow } from './flow';

